export function reactHrefDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: reactHrefDirectiveCtrl,
	};
}

export class reactHrefDirectiveCtrl {
	constructor($element, $attrs) {
		'ngInject';
		$attrs.$observe('shReactHref', () => {
			$element[0].href = window.BASE_URL + $attrs.shReactHref;
		});
	}
}
